import { useMemo } from 'react';
import type { CreativesByHypothesis } from 'features/creatives';
import type { HypothesisCreativeEntry, HypothesisGroup } from '../types/hypothesis';
import compareHypothesisNames from '../utils/compareHypothesisNames';

interface UseHypothesisGroupsReturn {
  groups: HypothesisGroup[];
  hypothesisCount: number;
}

const sortByLaunchStatus = (creatives: HypothesisCreativeEntry[]) =>
  [...creatives].sort((a, b) => {
    if (a.launch_status === 'launched' && b.launch_status !== 'launched') return -1;
    if (a.launch_status !== 'launched' && b.launch_status === 'launched') return 1;
    return 0;
  });

const sectionForGroup = (creatives: HypothesisCreativeEntry[]) => {
  if (creatives.some((creative) => creative.section === 'this_week')) return 'this_week';
  if (creatives.some((creative) => creative.section === 'upcoming')) return 'upcoming';
  return null;
};

const useHypothesisGroups = (
  creativesByHypothesis: CreativesByHypothesis<HypothesisCreativeEntry>,
): UseHypothesisGroupsReturn =>
  useMemo(() => {
    const groups = Object.entries(creativesByHypothesis).map(
      ([hypothesis, creatives]): HypothesisGroup => ({
        hypothesis,
        section: sectionForGroup(creatives),
        creatives: sortByLaunchStatus(creatives),
      }),
    );

    return {
      groups: groups.sort((a, b) => compareHypothesisNames(a.hypothesis, b.hypothesis)),
      hypothesisCount: groups.length,
    };
  }, [creativesByHypothesis]);

export default useHypothesisGroups;
